import { render, staticRenderFns } from "./IconMail.vue?vue&type=template&id=3dcb686a&"
import script from "./IconMail.vue?vue&type=script&lang=js&"
export * from "./IconMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports